"use strict";

$(document).ready(function () {
  if ($('.instagram_block').length > 0) {
    var instagramSwiper = instagram_slider(); // setTimeout(function(){
    //     $('.instagram_post').each(function (){
    //         var thisEl = $(this);
    //         var thisImgUrl = thisEl.attr('data-instagram-img');
    //         var imgStr = "url('" + thisImgUrl + "')";
    //         thisEl.removeClass('empty');
    //         thisEl.css('background-image', imgStr);
    //         thisEl.removeClass('load');
    //     });
    // }, 800);

    $('.instagram_post.empty.load').Lazy({
      beforeLoad: function beforeLoad(element) {// called before an elements gets handled
      },
      afterLoad: function afterLoad(element) {
        // called after an element was successfully handled
        $(element).removeClass('empty');
        $(element).removeClass('load');
      },
      onError: function onError(element) {// called whenever an element could not be handled
      },
      onFinishedAll: function onFinishedAll() {// called once all elements was handled
      }
    });
    instagramSwiper.on('slideChange', function () {
      $('.instagram_post.empty.load').Lazy({
        afterLoad: function afterLoad(element) {
          // called after an element was successfully handled
          $(element).removeClass('empty');
          $(element).removeClass('load');
        }
      });
    });

    if ($('.latest-posts .photo.empty.load').length > 0) {
      $('.latest-posts .photo.empty.load').Lazy({
        beforeLoad: function beforeLoad(element) {// called before an elements gets handled
        },
        afterLoad: function afterLoad(element) {
          // called after an element was successfully handled
          $(element).removeClass('empty');
          $(element).removeClass('load');
        },
        onError: function onError(element) {// called whenever an element could not be handled
        },
        onFinishedAll: function onFinishedAll() {// called once all elements was handled
        }
      });
    }
  }
});

function instagram_slider() {
  var swiper = new Swiper('.instagram_block .swiper-container', {
    slidesPerView: 4,
    // slidesPerColumn: 2,
    // direction: 'horizontal',
    // slidesPerColumnFill: 'row',
    spaceBetween: 25,
    pagination: {
      el: '.instagram_block .swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.instagram_block .swiper-button-next',
      prevEl: '.instagram_block .swiper-button-prev'
    } // breakpoints: {
    //     1150: {
    //         slidesPerView: 4,
    //         slidesPerColumn: 1,
    //     }
    // }

  });
  return swiper;
}